import Parse from "parse/dist/parse.min.js";

const isProd = process.env.NODE_ENV == "production";
let parseAppId, parseServerUrl;

if (isProd) {
  parseAppId = process.env.VUE_APP_PARSE_PROD_APP_ID;
  parseServerUrl = process.env.VUE_APP_PARSE_PROD_URL;
} else {
  parseAppId = "829f6623a9fe79d531194644f742e5e0458a1ebd";
  parseServerUrl = "https://happy.test.jadeh.co/parse";
}

Parse.initialize(parseAppId);
Parse.serverURL = parseServerUrl;

// disable retry on failed requests
Parse.CoreManager.set("REQUEST_ATTEMPT_LIMIT", 1);

export { parseAppId, parseServerUrl };
export default Parse;
